module.exports = __webpack_public_path__ + "img/yabanci-uyruklu-saglik-sigortasi.c78a1fa3.svg";